import { Info } from "lucide-react";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/app/components/ui/tooltip";
import { LevelsOfExperience } from "../../models/resume/template";

function SelectExperience() {
	const levelsObject = new LevelsOfExperience();
	const listOfExperience = levelsObject.listOfExperience;
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const template = useSelector((state) => state.TemplateSelectionReducer);
	const navigationFlow = template.navigationFlow;

	function onSelectionClick(levelName) {
		localStorage.setItem("yearsOfExperience", levelName);

		dispatch({
			type: "",
			payload: {
				selectedTemplate: {
					yearsOfExperience: levelName,
					templateName: "",
				},
				navigationFlow: navigationFlow,
			},
		});

		navigate("/resume/select-template");
	}

	const [showTemplates, setShowTemplates] = useState(false);
	return (
		<>
			<>
				<>
					<>
						<div className="mb-6">
							<h2 className="tr-title-big">How long have you been working?</h2>
							<p className="flex gap-1">
								We will find the best templates for your experience level.{" "}
								<Tooltip className="inline">
									<TooltipTrigger className="cursor-pointer text-base p-0" onClick={() => setShowTemplates(true)}>
										<Info className="h-4 w-4 text-primary-600" />
									</TooltipTrigger>
									<TooltipContent variant="plain">
										Click to learn more about our professionally crafted templates.
									</TooltipContent>
								</Tooltip>
							</p>
						</div>
						<div className="">
							<div className="grid grid-cols-2 md:grid-cols-4 gap-3">
								{listOfExperience
									.filter((ex) => ex.showInList === true)
									.map((experience) => (
										<React.Fragment key={experience.name}>
											<div onClick={() => onSelectionClick(experience.name)}>
												<div className="d-block text-dark font-weight-semi w-100 text-center p-5  shadow-sm select-experience-level">
													{experience.name}
												</div>
											</div>
										</React.Fragment>
									))}
							</div>
						</div>
					</>
				</>
				{showTemplates && (
					<div className="p-5">
						<div className="resume-career-path">
							<div className="container">
								<div className="text-center mb-md-5 mb-4">
									<h2 className="mb-3">Resume Templates for Every Career Path.</h2>
									<div className="row justify-content-center">
										<div className="col-md-10">
											<p>
												Choose from our professionally designed templates and build your effective resume instantly. Our
												templates are suitable for any professions and industries. Highlights key skills,
												qualifications, and present your credentials in a professionally appealing way. <br />
												Helping you to make a great first impression, even if you&#39;re new to resume writing!
											</p>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-md-4 mb-4 mb-md-0">
										<div className="career-resume-box  ">
											<div className="img p-2 bg-white mb-4 rounded overflow-hidden">
												<img src="/images/resume-template/template-1.png" className="w-100 img-thumbnail" alt="" />
											</div>
											<h4>College Resume Template</h4>
											<p>No experience? No problem! We&#39;ll guide you.</p>
										</div>
									</div>
									<div className="col-md-4 mb-4 mb-md-0">
										<div className="career-resume-box  ">
											<div className="img p-2 bg-white mb-4 rounded overflow-hidden">
												<img src="/images/resume-template/template-9.png" className="w-100 img-thumbnail" alt="" />
											</div>
											<h4>Professional Resume Template</h4>
											<p>Communicate your value confidently!</p>
										</div>
									</div>
									<div className="col-md-4">
										<div className="career-resume-box  ">
											<div className="img p-2 bg-white mb-4 rounded overflow-hidden">
												<img src="/images/resume-template/template-10.png" className="w-100 img-thumbnail" alt="" />
											</div>
											<h4>Expertly Crafted Template</h4>
											<p>Say more with less!</p>
										</div>
									</div>
								</div>
								<div className="mt-4 text-center">
									<a href="/resume/select-template" className="btn btn-primary">
										Discover More Resume Templates
									</a>
								</div>
							</div>
						</div>
					</div>
				)}
			</>
		</>
	);
}

export default SelectExperience;
